import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TeacherLogin } from '@/components/onboarding/TeacherLogin';
import { TeacherPasswordSetup } from '@/components/onboarding/TeacherPasswordSetup';
import { getOnboardingState, saveOnboardingState, saveTeacherCredentials } from '@/lib/onboarding-store';

function getBackDestination(): string {
  const state = getOnboardingState();
  // If the user's stored identity is a school admin, return them to the school login page
  return state.userType === 'school' ? '/school/login' : '/';
}

type LocalView = 'login' | 'password-setup';

export function TeacherLoginPage() {
  const navigate = useNavigate();
  const [view, setView] = useState<LocalView>('login');
  const [tempTeacher, setTempTeacher] = useState<{
    name: string;
    email: string;
    department: string;
  } | null>(null);

  const handleLogin = (
    teacherName: string,
    email: string,
    department: string,
    hasPassword: boolean,
    accessToken?: string,
    userId?: string,
  ) => {
    if (accessToken) sessionStorage.setItem('cmc_teacher_token', accessToken);
    if (userId) sessionStorage.setItem('cmc_teacher_id', userId);

    const state = getOnboardingState();

    if (hasPassword) {
      saveOnboardingState({
        ...state,
        teacherName,
        teacherEmail: email,
        teacherDepartment: department,
        isComplete: true,
        userType: 'teacher',
      });
      navigate('/');
    } else {
      setTempTeacher({ name: teacherName, email, department });
      setView('password-setup');
    }
  };

  const handlePasswordSetup = (password: string) => {
    if (!tempTeacher) return;
    const state = getOnboardingState();

    saveTeacherCredentials({
      code: state.teacherCode || '',
      email: tempTeacher.email,
      password,
      name: tempTeacher.name,
      department: tempTeacher.department,
    });

    saveOnboardingState({
      ...state,
      teacherName: tempTeacher.name,
      teacherEmail: tempTeacher.email,
      teacherDepartment: tempTeacher.department,
      teacherPassword: password,
      isComplete: true,
      userType: 'teacher',
    });

    navigate('/');
  };

  if (view === 'password-setup' && tempTeacher) {
    return (
      <TeacherPasswordSetup
        teacherName={tempTeacher.name}
        onComplete={handlePasswordSetup}
      />
    );
  }

  return (
    <TeacherLogin
      onLogin={handleLogin}
      onBack={() => navigate(getBackDestination())}
    />
  );
}
